var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVoucherAction = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4883 17.9561H2.07422C1.47852 17.9561 1 17.4727 1 16.877V4.94336V4.0791C1 3.4834 1.4834 3 2.07422 3H21.4883C22.084 3 22.5625 3.4834 22.5625 4.0791V4.93848V16.8721C22.5625 17.4727 22.0791 17.9561 21.4883 17.9561Z",
    fill: "#008000",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 8.68848H20.9658",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07715 8.68848H11.6699",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46973 11.2715H3.34961C2.96387 11.2715 2.65137 10.959 2.65137 10.5732V8.23926C2.65137 7.85352 2.96387 7.54102 3.34961 7.54102H6.46973C6.85547 7.54102 7.16797 7.85352 7.16797 8.23926V10.5732C7.16797 10.959 6.85547 11.2715 6.46973 11.2715Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65234 8.75684H4.16602V11.2715",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65234 10.0508H4.16602",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51855 7.72144V9.40601V11.2273",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16895 10.114H5.51855",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51855 8.75659H7.16895",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3574 6.11548H1.15625",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07617 10.4514H21.0195",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95996 13.6445L3.2373 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2373 13.6445L3.95996 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71289 13.6445L4.99023 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99023 13.6445L5.71289 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46484 13.6445L6.74219 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74219 13.6445L7.46484 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3896 13.6445L9.66211 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66211 13.6445L10.3896 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1426 13.6445L11.4199 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4199 13.6445L12.1426 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8965 13.6445L13.1738 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1738 13.6445L13.8965 14.3721",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4883 17.9563H2.07422C1.47852 17.9563 1 17.4729 1 16.8772V4.9436V4.07935C1 3.48364 1.4834 3.00024 2.07422 3.00024H21.4883C22.084 3.00024 22.5625 3.48364 22.5625 4.07935V4.93872V16.8723C22.5625 17.4729 22.0791 17.9563 21.4883 17.9563Z",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7109 21.467C22.3052 21.467 24.4082 19.3531 24.4082 16.7454C24.4082 14.1376 22.3052 12.0237 19.7109 12.0237C17.1167 12.0237 15.0137 14.1376 15.0137 16.7454C15.0137 19.3531 17.1167 21.467 19.7109 21.467Z",
    fill: "#F53759",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7988 13.9817V19.7336",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.665 16.8577H16.9375",
    stroke: "white",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7949 13.1125C21.8154 13.1125 22.7627 13.4397 23.5342 13.9963C22.6797 12.8049 21.2881 12.0237 19.7158 12.0237C17.1182 12.0237 15.0186 14.1379 15.0186 16.7454C15.0186 18.3274 15.7949 19.7239 16.9814 20.5833C16.4297 19.8069 16.1025 18.8596 16.1025 17.8342C16.0928 15.2268 18.1973 13.1125 20.7949 13.1125Z",
    fill: "#DD3051"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7109 21.467C22.3052 21.467 24.4082 19.3531 24.4082 16.7454C24.4082 14.1376 22.3052 12.0237 19.7109 12.0237C17.1167 12.0237 15.0137 14.1376 15.0137 16.7454C15.0137 19.3531 17.1167 21.467 19.7109 21.467Z",
    stroke: "black",
    strokeWidth: 0.732422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVoucherAction, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/voucherAction.9a3fdc8d.svg";
export { ForwardRef as ReactComponent };